<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view :key="$router.path"/>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'App',

  mixins: [
    require('./mixins/timers.js')
  ],

  created () {
    this.$store.dispatch('pages/logApp')
    this.$store.dispatch('pages/getAllContent')
    this.$store.dispatch('osc/startOSCConnection')
    this.setupTimer()
  }
}
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }
  .fade-leave-active {
    transition-duration: 0.1s;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
